import React from 'react';
import { Spot } from 'utils/constants';
import { LatLng } from 'utils/spotSearch';
import SpotCardResult from './SpotCardResult';
import styles from './FindParking.module.css';

type ResultsProps = {
    spots: Spot[];
    rentalType: string;
    origin?: LatLng;
    activeSpotPk: Spot['pk'] | null;
    selectedSpotPk: Spot['pk'] | null;
    loading: boolean;
    onHover: (spotPk: Spot['pk'] | null) => void;
    onSelect: (spot: Spot) => void;
};

const Results: React.FC<ResultsProps> = ({
    spots,
    rentalType,
    origin,
    activeSpotPk,
    selectedSpotPk,
    loading,
    onHover,
    onSelect,
}) => {
    if (spots.length === 0) {
        return (
            <div className={styles.emptyState}>
                {loading
                    ? 'Finding locations near you'
                    : 'No locations found here. Move the map to search another area.'}
            </div>
        );
    }

    return (
        <>
            {spots.map((spot) => (
                <SpotCardResult
                    key={spot.pk}
                    spot={spot}
                    rentalType={rentalType}
                    origin={origin}
                    active={spot.pk === activeSpotPk}
                    selected={spot.pk === selectedSpotPk}
                    onHover={onHover}
                    onSelect={onSelect}
                />
            ))}
        </>
    );
};

export default Results;
